query MobileBusinessUnitsTableData(
	$days: Int!
	$calculationDateFrom: ConditionDateTime
	$calculationDateTo: ConditionDateTime
	$platformFilter: ConditionString
	$appIdFilter: ConditionString
) {
	score_mobile_products(
		timeframe_days_eq: { value: [$days] }
		calculation_date_ge: $calculationDateFrom
		calculation_date_le: $calculationDateTo
		platform_eq: $platformFilter
		app_id_eq: $appIdFilter
		unit_id_ne: { value: [""] }
	) {
		unit_id
		platform
		app_id
		timeframe_days
		calculation_date
		unique_issues_critical
		unique_issues_serious
		unique_issues
		score
	}
}
